class animateJS {
    constructor() {
       this.domEvents();
       this.onLoadVisibleElements();
    }
 

    onLoadVisibleElements(){
      this._animateOnscroll();
    }


    /**
     * document event listners
     */
    domEvents = () => {
         document.addEventListener('scroll' , () => {
            this._animateOnscroll();
         })
    }

    /**
     * Animate the svg on scroll anf if element get visible in viewport
     */
    _animateOnscroll(){
      let joffrey_position ,relatedLeft_position, relatedRight_position, shopLeft_position , shopRight_position,
      joffrey_moments , disneyRight_position , bestseller_postion,disneySpring_postion , disneyLeft_position,
      roastmaster_postion ,leftpromowholesale_position , wholesaleLeft_position,midtownRight_position;

      document.querySelector('.joffreys-moment-left') ? joffrey_position = document.querySelector('.joffreys-moment-left').getBoundingClientRect(): '' ;
      document.querySelector('.joffreys-moment-right') ? joffrey_moments = document.querySelector('.joffreys-moment-right').getBoundingClientRect() : '' ; 
      document.querySelector('[data-bestSeller]') ? bestseller_postion = document.querySelector('[data-bestSeller]').getBoundingClientRect() : '' ;
      document.querySelector('[data-disneySpring]') ? disneySpring_postion = document.querySelector('[data-disneySpring]').getBoundingClientRect() : '' ;
      document.querySelector('[data-roastmaster]') ? roastmaster_postion = document.querySelector('[data-roastmaster]').getBoundingClientRect() : '' ;
      document.querySelector('[data-leftpromowholesale]') ? leftpromowholesale_position = document.querySelector('[data-leftpromowholesale]').getBoundingClientRect() : '' ;
      document.querySelector('[data-wholesaleLeft]') ? wholesaleLeft_position = document.querySelector('[data-wholesaleLeft]').getBoundingClientRect() : '' ;
      document.querySelector('[data-relatedLeft]') ? relatedLeft_position = document.querySelector('[data-relatedLeft]').getBoundingClientRect() : '' ;
      document.querySelector('[data-relatedRight]') ? relatedRight_position = document.querySelector('[data-relatedRight]').getBoundingClientRect() : '' ;
      document.querySelector('[data-disneyRight]') ? disneyRight_position = document.querySelector('[data-disneyRight]').getBoundingClientRect() : '' ;
      document.querySelector('[data-disneyLeft]') ? disneyLeft_position = document.querySelector('[data-disneyLeft]').getBoundingClientRect() : '' ;
      document.querySelector('[data-shopLeft]') ? shopLeft_position = document.querySelector('[data-shopLeft]').getBoundingClientRect() : '' ;
      document.querySelector('[data-shopRight]') ? shopRight_position = document.querySelector('[data-shopRight]').getBoundingClientRect() : '' ;
      document.querySelector('[data-midtownRight]') ? midtownRight_position = document.querySelector('[data-midtownRight]').getBoundingClientRect() : '' ;
    

      if(joffrey_position != null)
      joffrey_position.bottom <= window.innerHeight ? document.querySelector('.joffreys-moment-left').classList.add('visible') : '';
  
      if(joffrey_moments != null)
      joffrey_moments.bottom <= window.innerHeight ? document.querySelector('.joffreys-moment-right').classList.add('visible') : '';
    
      if(bestseller_postion != null)
      bestseller_postion.bottom <= window.innerHeight ? document.querySelector('[data-bestSeller]').classList.add('visible') : '';
      
      if(disneySpring_postion != null)
         disneySpring_postion.top <= window.innerHeight ? document.querySelector('[data-disneySpring]').classList.add('visible') : '';
      
      if(roastmaster_postion != null)
      roastmaster_postion.top <= window.innerHeight ? document.querySelector('[data-roastmaster]').classList.add('visible') : '';

      if(wholesaleLeft_position != null)
      wholesaleLeft_position.top <= window.innerHeight ? document.querySelector('[data-wholesaleLeft]').classList.add('visible') : '';

      if(relatedLeft_position != null)
      relatedLeft_position.top <= window.innerHeight ? document.querySelector('[data-relatedLeft]').classList.add('visible') : '';

      if(relatedRight_position != null)
      relatedRight_position.top <= window.innerHeight ? document.querySelector('[data-relatedRight]').classList.add('visible') : '';

      if(disneyRight_position != null)
      disneyRight_position.top <= window.innerHeight ? document.querySelector('[data-disneyRight]').classList.add('visible') : '';

      if(disneyLeft_position != null)
      disneyLeft_position.top <= window.innerHeight ? document.querySelector('[data-disneyLeft]').classList.add('visible') : '';
     
      if(shopRight_position != null)
      shopRight_position.top <= window.innerHeight ? document.querySelector('[data-shopRight]').classList.add('visible') : '';
     
      if(shopLeft_position != null)
      shopLeft_position.top <= window.innerHeight ? document.querySelector('[data-shopLeft]').classList.add('visible') : '';

      if(midtownRight_position != null)
      midtownRight_position.top <= window.innerHeight ? document.querySelector('[data-midtownRight]').classList.add('visible') : '';

      }

      
}

typeof animateJS !== 'undefined' && new animateJS();


